import DOMUtils from "@utils/dom.utils";

function menuItemChanged(elements, selector) {
  return Array.prototype.slice.call(elements).filter((el) => DOMUtils.hasClass(el, selector))
    .length;
}

function containerElMenuItemChanged(mutations, selector) {
  let changed = false;
  mutations.forEach((mutation) => {
    if (changed) return false;
    if (mutation.type === "childList") {
      changed =
        menuItemChanged(mutation.addedNodes, selector) ||
        menuItemChanged(mutation.removedNodes, selector);
    } else if (mutation.type === "attributes" && mutation.attributeName === "class") {
      changed = menuItemChanged([mutation.target], selector);
    } else if (mutation.type === "attributes" && mutation.attributeName === "aria-checked") {
      changed = true;
    }
  });
  return changed;
}

export default {
  data() {
    return {
      containerElObserver: null,
      containerElMenuItemSelector: "",
    };
  },
  computed: {
    containerElHeaderOptions() {
      return this.options.filter((opt) => opt.header);
    },
    hasContainerElHeaderOptions() {
      return this.containerElHeaderOptions.length;
    },
  },
  methods: {
    processContainerElMenuItems() {
      if (!this.$refs.containerEl?.options) {
        return;
      }
      //https://stackoverflow.com/questions/71414977/refs-inside-v-for-loop-for-vue-v3-2-25-or-above
      //https://github.com/vuejs/core/issues/5525
      DOMUtils.elOf(this.$refs.containerEl.$el, ".bx--list-box__menu-item").forEach((el, index) => {
        if (this.$refs.containerEl.options[index].header) {
          if (!DOMUtils.hasClass(el, "box__menu-header")) {
            DOMUtils.addClass(el, "box__menu-header");
          }

          // remove highlighted class to prevent hover effect on header option
          if (DOMUtils.hasClass(el, "bx--list-box__menu-item--highlighted")) {
            DOMUtils.removeClass(el, "bx--list-box__menu-item--highlighted");
          }

          // FOR MULTI-SELECT: filter out header value from dataValue list of multi-select component
          // the case when user press enter key twice on the input field,
          // the first header option will be selected and saved into dataValue list
          const headerValue = this.$refs.containerEl.options[index].value;
          if (
            Array.isArray(this.$refs.containerEl.dataValue) &&
            this.$refs.containerEl.dataValue.includes(headerValue)
          ) {
            this.$refs.containerEl.dataValue = this.$refs.containerEl.dataValue.filter(
              (value) => value !== headerValue,
            );
          }
        } else {
          // if the item is not header but having header css class, remove the header css class
          if (DOMUtils.hasClass(el, "box__menu-header")) {
            DOMUtils.removeClass(el, "box__menu-header");
          }
        }

        // Set depth for multilevel item
        if (this.$refs.containerEl.options[index].depth) {
          el.setAttribute("data-depth", this.$refs.containerEl.options[index].depth);
          DOMUtils.setCSSVariableInElement(
            el,
            "--depth",
            this.$refs.containerEl.options[index].depth,
          );
        }

        // Add title attribute to display browser tooltip
        let menuItemOption = el.childNodes[0];
        DOMUtils.setAttr(menuItemOption, "title", menuItemOption.textContent);
      });

      // FOR MULTI-SELECT: filter out empty string from dataValue list of multi select component
      // the case when user input value (not within options) and press enter
      // empty string will get saved in dataValue list
      if (
        Array.isArray(this.$refs.containerEl.dataValue) &&
        this.$refs.containerEl.dataValue.length > 0
      ) {
        this.$refs.containerEl.dataValue = this.$refs.containerEl.dataValue.filter(
          (value) => value !== "",
        );
      }
    },
    onContainerElChanged(mutations) {
      if (containerElMenuItemChanged(mutations, this.containerElMenuItemSelector)) {
        this.processContainerElMenuItems();
      }
    },

    observeContainerElChanges() {
      if (this.containerElObserver) this.containerElObserver.disconnect();
      this.containerElObserver = new MutationObserver(this.onContainerElChanged);
      this.containerElObserver.observe(this.$el, {
        childList: true,
        subtree: true,
        attributes: true,
      });
    },
    setTitleAttributeForDisabledState() {
      const textInput = DOMUtils.elOf(this.$el, ".bx--text-input")[0];
      if (textInput) {
        DOMUtils.setAttr(textInput, "title", textInput.placeholder);
      }
    },
    // FOR MULTI-SELECT: disable options that have disabled property
    processDisabledOptions() {
      if (!this.$refs.containerEl?.$refs.option) {
        return;
      }
      DOMUtils.elOf(this.$refs.containerEl.$el, ".bx--list-box__menu-item").forEach((el, index) => {
        if (DOMUtils.attr(el, "disabled")) {
          el.removeAttribute("disabled");
        }
        if (this.$refs.containerEl.options[index].disabled) {
          DOMUtils.setAttr(el, "disabled", "true");
        }
      });
    },
  },
  created() {
    this.containerElMenuItemSelector = "bx--list-box__menu-item";
  },
  mounted() {
    if (this.$options && this.$options.props.disabled) {
      setTimeout(this.setTitleAttributeForDisabledState, 300);
    }
    this.processContainerElMenuItems();
    this.observeContainerElChanges();
    this.processDisabledOptions();
  },
  updated() {
    this.processDisabledOptions();
  },
  beforeUnmount() {
    if (this.containerElObserver) this.containerElObserver.disconnect();
  },
};
